import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import PublicNavbar from './PublicNavbar';
import PublicFooter from './PublicFooter';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <PublicNavbar solid />
      <Container className="text-center" style={{ paddingTop: '140px', paddingBottom: '100px', flex: 1 }}>
        <h1 style={{ fontSize: '6rem', fontWeight: 700, color: '#e0e0e0', marginBottom: 0 }}>404</h1>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 600, color: '#333', marginBottom: '12px' }}>Page Not Found</h2>
        <p style={{ color: '#666', maxWidth: '400px', margin: '0 auto 32px' }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Button
          variant="dark"
          size="lg"
          onClick={() => navigate('/')}
          style={{ borderRadius: '8px', padding: '10px 32px' }}
        >
          Go Home
        </Button>
      </Container>
      <PublicFooter />
    </div>
  );
};

export default NotFound;
